import React from 'react';
import { twMerge } from 'utilities/src/twMerge';

type MainContainerProps = {
  children: React.ReactNode;
  className?: string;
};

export const mainContainerClassName =
  'mdS:mx-6 lgS:max-w-[76rem] lgS:mx-auto mx-4 xl:max-w-[82rem] 2xl:max-w-[94rem]';

export default function MainContainer({ children, className }: MainContainerProps) {
  return <div className={twMerge(mainContainerClassName, className)}>{children}</div>;
}
